export default "__VITE_ASSET__sKKZ596x__";